export default __webpack_public_path__ + "static/GraphikLCWeb-Medium-0ea9f73b4e888f61149e3976e37306a9.woff";